<template>
	<div class="h">
		<div class="login">
			<div class="leftdiv">
				<el-carousel height="100%" style="height: 100%;">
					<el-carousel-item v-for="(v,k) in (appdata.list.ad_register_list || [])" :key="k">
						<img class="img" :src="v.pic">
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="rightdiv">
				<div class="tabs">
					<div :class="tabshow == 1?'checked': ''" @click="tabshow = 1">密码登录</div>
					<div :class="tabshow == 2?'checked': ''" @click="tabshow = 2">手机验证码登录</div>
				</div>
				<el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" class="login-form"
					@submit.prevent="handlelogin" v-if="tabshow == 1">

					<el-form-item prop="username">
						<el-input v-model="loginForm.username" placeholder="请输入登录名" class="custom-input" />
					</el-form-item>

					<el-form-item prop="password">
						<el-input v-model="loginForm.password" type="password" placeholder="请输入密码" class="custom-input"
							autocomplete="new-password" />
						<span class="verify-btn" @click="onwjmm()">
							忘记密码
						</span>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" size="small" class="login-btn" :loading="loading"
							@click="handlelogin">
							{{ loading ? '登录中...' : '登录' }}
						</el-button>
					</el-form-item>
				</el-form>

				<el-form ref="codeForm" :model="codeForm" :rules="loginRules" class="login-form"
					@submit.prevent="handlelogin" v-if="tabshow == 2">

					<el-form-item prop="phone">
						<el-input v-model="codeForm.phone" placeholder="请输入手机号" class="custom-input" />
					</el-form-item>

					<el-form-item prop="code">
						<el-input v-model="codeForm.code" placeholder="请输入验证码" class="yzm-input" />
						<span class="verify-btn" @click="handleGetVerifyCode">
							{{ verifyCodeText }}
						</span>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" size="small" class="login-btn" :loading="loading"
							@click="handlecodelogin">
							{{ loading ? '登录中...' : '登录' }}
						</el-button>
					</el-form-item>
				</el-form>

				<div class="mfzc">
					<span class="a" @click="$router.push('/register')">免费注册</span>
				</div>
			</div>

			<el-dialog title="验证码" :visible.sync="yzmshow" width="440px">
				<el-form :model="yzmform" ref="yzmform" :rules="yzmRules">
					<el-form-item class="yzmitem" prop="yzm">
						<el-input v-model="yzmform.yzm" placeholder="请输入验证码" class="yzminput"></el-input>
						<img :src="imgsrc" class="imgsrc" @click="generateRandomLetters()">
					</el-form-item>
				</el-form>

				<div slot="footer" class="dialog-footer">
					<el-button @click="onyzmgb()" size="small">取消</el-button>
					<el-button type="primary" @click="onyzmsub()" size="small">确定</el-button>
				</div>
			</el-dialog>

			<forget :fshow.sync="wjmm"></forget>
		</div>
		<myfooter></myfooter>
	</div>
</template>

<script>
	import { getPddPati } from '@/libraries/utils/pddPati'

	export default {
		name: 'Login',
		data() {
			var validatePhone = (rule, value, callback) => {
				const phoneReg = /^1[3-9]\d{9}$/
				if (value == '') {
					callback(new Error('请输入手机号'))
				} else if (!phoneReg.test(value)) {
					callback(new Error('请输入正确的手机号'))
				} else {
					callback()
				}
			}
			return {
				loading: false,
				loginForm: {
					username: '',
					password: '',
				},

				codeForm: {
					phone: '',
					code: ''
				},

				loginRules: {
					username: [{
							required: true,
							message: '请输入登录名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '登录名长度在 3 到 20 个字符',
							trigger: 'blur'
						}
					],

					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],

					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],

					code: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						{
							len: 4,
							message: '验证码为4位数字',
							trigger: 'blur'
						}
					]
				},

				tabshow: 1,
				verifyCodeDisabled: false,
				verifyCodeText: '获取验证码',

				yzmshow: false,
				randomLetters: "",
				imgsrc: "",
				yzmform: {
					yzm: "",
				},

				yzmRules: {
					yzm: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				},

				wjmm: false
			}
		},

		inject: ['reload', 'appdata'],

		mounted() {
			document.title = "登录";
		},

		methods: {
			submitLogin(payload) {
				this.loading = true
				return getPddPati().then(function(pati) {
					payload.pati = pati
					return this.$axios.post('api/user/login', payload)
				}.bind(this)).then(function(res) {
					if (res.data.code == 0) {
						this.$message.success('登录成功')
						this.$cookies.set('token', res.data.data.token)
						this.reload()
						this.$router.push('/home')
					} else {
						this.$message.error(res.data.message)
					}
				}.bind(this)).catch(function(err) {
					console.log(err)
					this.$message.error('登录失败，请稍后重试')
				}.bind(this)).finally(function() {
					this.loading = false
				}.bind(this))
			},

			handlelogin() {
				this.$refs['loginFormRef'].validate((valid) => {
					if (valid) {
						this.submitLogin(Object.assign({}, this.loginForm))
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},

			handlecodelogin() {
				this.$refs['codeForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.codeForm))
						obj.username = obj.phone
						this.submitLogin(obj)
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},

			handleGetVerifyCode() {
				if (this.verifyCodeDisabled) {
					return;
				}

				if (!this.codeForm.phone) {
					this.$message.warning('请先输入手机号');
					return
				}

				// 验证手机号格式
				const phoneReg = /^1[3-9]\d{9}$/
				if (!phoneReg.test(this.codeForm.phone)) {
					this.$message.warning('请输入正确的手机号')
					return
				}
				this.generateRandomLetters();
				this.yzmshow = true;
			},

			generateRandomLetters() {
				let result = '';
				for (let i = 0; i < 4; i++) {
					const randomCharCode = Math.floor(Math.random() * 26) + 65; // 生成65到90之间的随机数，对应大写字母A-Z
					result += String.fromCharCode(randomCharCode);
				}
				this.randomLetters = result + new Date().getTime();
				this.imgsrc = "http://api.zhidayd.com/adapipublic/captcha?uniq=" + this.randomLetters;
			},

			onyzmsub() {
				this.$refs['yzmform'].validate((valid) => {
					if (valid) {
						var params = {
							mobile: this.codeForm.phone,
							uniq: this.randomLetters,
							captcha: this.yzmform.yzm
						};
						this.$axios.post('api/sms/send', params).then(res => {
							if (res.data.code == 0) {
								this.$message.success('验证码已发送');
								this.verifyCodeDisabled = true;
								this.countdown = 60;
								this.onyzmgb();
								const timer = setInterval(() => {
									this.countdown--
									this.verifyCodeText = `${this.countdown}秒后重试`
									if (this.countdown <= 0) {
										clearInterval(timer)
										this.verifyCodeDisabled = false
										this.verifyCodeText = '获取验证码'
									}
								}, 1000);
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onyzmgb() {
				this.yzmform.yzm = "";
				this.yzmshow = false;
			},

			onwjmm() {
				this.wjmm = true;
			}
		}
	}
</script>

<style scoped lang="less">

	.h {
		min-height: calc(100vh - 60px);
	}
	
	.login {
		width: 100%;
		height: calc(100vh - 60px);
		display: flex;
	}

	.leftdiv {
		flex: 1;
		min-width: 0;
		height: 100%;

		.img {
			width: 100%;
			height: 100%;
		}
	}

	.rightdiv {
		width: 550px;
		min-width: 550px;
		height: 100%;
		// padding: 10% 5%;
		box-sizing: border-box;
		overflow-y: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		.tabs {
			width: 323px;
			display: flex;
			align-items: center;
			margin-bottom: 40px;

			div {
				color: #666;
				font-size: 20px;
				cursor: pointer;
				margin-right: 40px;
			}

			div:last-child {
				margin-right: 0;
			}

			.checked {
				font-size: 26px;
				color: #333;
				position: relative;
				font-weight: 600;
			}

			.checked::after {
				content: '';
				width: 100%;
				height: 3px;
				background: #F65730;
				position: absolute;
				left: 0;
				bottom: -10px;
			}
		}

		.login-form {
			width: 323px;
		}
	}

	.login-btn {
		background-color: #F65730;
		color: #fff;
		width: 100%;
		text-align: center;
		border: 0;
		font-size: 14px;
		border-radius: 10px;
		display: block;
		cursor: pointer;
		height: 38px;
		margin-top: 50px;
	}

	.mfzc {
		width: 323px;
		display: flex;
		justify-content: flex-end;

		.a {
			color: #2D93FF;
			font-size: 16px;
			cursor: pointer;
		}
	}

	.verify-btn {
		position: absolute;
		right: 14px;
		font-size: 14px;
		color: #2D93FF;
		cursor: pointer;
	}

	.yzmitem {
		position: relative;
	}

	.imgsrc {
		width: 120px;
		height: 36px;
		cursor: pointer;
		position: absolute;
		right: 2px;
		top: 2px;
	}
</style>

<style lang="less">
.login .el-form-item {
	margin-bottom: 20px;
}

.login .el-button--primary {
	background-color: #F65730;
	border-color: #F65730;
}



// WEBPACK FOOTER //
// src/components/login.vue